import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { RadioField, TextField, TextAreaField } from './../../../../../../components/fields';
import { formSettings } from './../settings';
import { getAdmin } from '../../../../../../reducers/onboarding';
import { history } from './../../../../../../configuration/store';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import messages from '../../../../../../text/messages';
import { setProgress } from '../../../../../../reducers/wizard';
import { Snackbar } from '../../../../../../components/snackbar';
import { getJobs } from '../../../../../../reducers/jobs';
import mixpanel from 'mixpanel-browser';
import { contractorType1099Label, contractorTypeLabel, jobDescriptionW2, jobDescriptionIC } from '../../../../../../utilities/regime';

class ChooseTypeStep extends React.Component {
    constructor(props) {
        super(props);

        this.getOptions = this.getOptions.bind(this);
        this.getDescription = this.getDescription.bind(this);
        this.submitReason = this.submitReason.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'intro', step: 'ChooseTypeStep' } });

        const { client, admin, getAdmin } = this.props;
        if (!admin) {
            getAdmin(client.admin_id);
        }
    }

    submitReason() {
        const { reason, comment, job, progress, setProgress, role, getJobs } = this.props;

        if (!comment && !reason) {
            Snackbar.error(<FormattedMessage id="noReasonError" defaultMessage="Please provide a reason above." />);
            return;
        }

        setProgress({ entity: 'job', id: job.id }, { ...progress, branch: 'dont-qualify-ic', help: { reason, comment } }, () => {
            Snackbar.success(<FormattedMessage {...{ ...messages.postSuccess, values: { name: 'Reason' } }} />);
            getJobs(role, () => history.push('/dashboard'));
        });
    }

    submitHelp() {
        const { reason, comment, job, progress, setProgress, role, getJobs } = this.props;

        setProgress({ entity: 'job', id: job.id }, { ...progress, branch: 'dont-know', help: { reason, comment } }, () => {
            Snackbar.success(<FormattedMessage {...{ ...messages.postSuccess, values: { name: 'Help request' } }} />);
            getJobs(role, () => history.push('/dashboard'));
        });
    }

    getDescription() {
        const { contractType } = this.props;

        switch (contractType) {
            case 'w2':
                return this.getOptionW2().description;

            case 'ic':
                return this.getOptionIC().description;

            case 'dont-know':
                return this.getOptionDontKnow().description;

            case 'dont-qualify-ic':
                return this.getOptionDontQualify().description;

            default:
                return null;
        }
    }

    getOptionW2() {
        const { contractType, admin, job } = this.props;

        return {
            label: (
                <div className="col-xs-12">
                    <div className="col-xs-12 single-type">
                        <div className="col-xs-2 hidden-xs hidden-sm hidden-md text-center">
                            <i className="material-icons jtc-icon">{contractType === 'w2' ? 'check_circle_outline' : 'radio_button_unchecked'}</i>
                        </div>
                        <div className="col-xs-12 col-lg-10 single-type-description">
                            <FormattedMessage id={'job.asAnIndividual'} defaultMessage={'As an Individual'} tagName={'h4'} />
                            <div className="hidden-xs hidden-sm hidden-md">
                                <FormattedMessage
                                    id={'job.ContractorType'}
                                    defaultMessage={contractorTypeLabel(job.regime)}
                                    values={{ admin: admin && admin.name }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            value: 'w2',
            description: (
                <div className="col-xs-12">
                    <div className="col-xs-12 contract-description">
                        <FormattedHTMLMessage
                            id={'job.EmployeeDescription'}
                            defaultMessage={jobDescriptionW2(job.regime)}
                            values={{ employer: admin && admin.employer }}
                            tagName={'div'}
                        />
                    </div>
                </div>
            )
        };
    }

    getOptionIC() {
        const { contractType, admin, job } = this.props;

        return {
            label: (
                <div className="col-xs-12">
                    <div className="col-xs-12 single-type">
                        <div className="col-xs-2 hidden-xs hidden-sm hidden-md text-center">
                            <i className="material-icons jtc-icon">{contractType === 'ic' ? 'check_circle_outline' : 'radio_button_unchecked'}</i>
                        </div>
                        <div className="col-xs-12 col-lg-10 single-type-description">
                            <FormattedMessage id={'job.asABusiness'} defaultMessage={'As a Business'} tagName={'h4'} />
                            <div className="hidden-xs hidden-sm hidden-md single-type-subhead">
                                <FormattedMessage id={'job.ContractorType'} defaultMessage={contractorType1099Label(job.regime)} />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            value: 'ic',
            description: (
                <div className="col-xs-12">
                    <div className="col-xs-12 contract-description">
                        <FormattedHTMLMessage
                            id={'job.ContractorDescription'}
                            defaultMessage={jobDescriptionIC(job.regime)}
                            values={{ employer: admin && admin.employer }}
                            tagName={'div'}
                        />
                    </div>
                </div>
            )
        };
    }

    getOptionDontQualify() {
        const { contractType } = this.props;

        return {
            label: (
                <div className="col-xs-12">
                    <div className="col-xs-12 single-type">
                        <div className="col-xs-2 hidden-xs hidden-sm hidden-md text-center">
                            <i className="material-icons jtc-icon">{contractType === 'dont-qualify-ic' ? 'check_circle_outline' : 'radio_button_unchecked'}</i>
                        </div>
                        <div className="col-xs-12 col-lg-10 single-type-description">
                            <FormattedMessage id={'job.dontqualify'} defaultMessage={`I don't qualify`} tagName={'h4'} />
                        </div>
                    </div>
                </div>
            ),
            value: 'dont-qualify-ic',
            description: (
                <div className="col-xs-12">
                    <div className="col-xs-12 contract-description">
                        <FormattedHTMLMessage
                            id={'job.DontQualifyDescription'}
                            defaultMessage={`<h4>If you <span className="italic">know</span> you don't qualify</h4> 
                                <p>If you are certain that you don't meet the criteria described in 'As a Business', then we're going to 
                                need to talk to the hiring company and get back to you.</p><p>
                                If that's your situation, please explain below 
                                why you are not an independent contractor, and press submit.</p><br/>`}
                            values={{}}
                            tagName={'div'}
                        />
                        <Field name="reason" component={TextField} placeholder={messages.reason} />
                        <Field name="comment" rows={6} component={TextAreaField} placeholder={messages.comment} />
                        <div className="text-center section">
                            <span className="button fit" onClick={this.submitReason}>
                                {' '}
                                <FormattedMessage {...messages.submit} />
                            </span>
                        </div>
                    </div>
                </div>
            )
        };
    }

    getOptionDontKnow() {
        const { contractType } = this.props;

        return {
            label: (
                <div className="col-xs-12">
                    <div className="col-xs-12 single-type">
                        <div className="col-xs-2 hidden-xs hidden-sm hidden-md text-center">
                            <i className="material-icons jtc-icon">{contractType === 'dont-know' ? 'check_circle_outline' : 'radio_button_unchecked'}</i>
                        </div>
                        <div className="col-xs-12 col-lg-10 single-type-description">
                            <FormattedMessage id={'job.dontknow'} defaultMessage={`I'm not sure`} tagName={'h4'} />
                        </div>
                    </div>
                </div>
            ),
            value: 'dont-know',
            description: (
                <div className="col-xs-12">
                    <div className="col-xs-12 contract-description">
                        <FormattedHTMLMessage
                            id={'job.NeedHelpDescription'}
                            defaultMessage={`<h4>If you <span className="italic">might</span> not qualify</h4> 
                                <p>You may not know whether you meet all the criteria for Independent Contractor
                                status.</p><p>In that case, go ahead and select 'As a Business' and enter your information; we'll 
                                do an evaluation and let you know.</p><br/>`}
                            values={{}}
                            tagName={'div'}
                        />
                    </div>
                </div>
            )
        };
    }

    getOptions() {
        const { job } = this.props;

        switch (job.classify_client_pref) {
            case 'ic-only':
                return [this.getOptionIC(), this.getOptionDontKnow(), this.getOptionDontQualify()];

            case 'w2-only':
                return [this.getOptionW2()];

            case 'w2-or-ic':
            default:
                return [this.getOptionW2(), this.getOptionIC()];
        }
    }

    getTypeStepDescription() {
        const { job } = this.props;
        const { classify_client_pref } = job || {};

        if (classify_client_pref === 'ic-only' || classify_client_pref === 'ic-preferred') {
            return (
                <span>
                    <FormattedMessage {...messages.chooseTypeStepDescription} />
                </span>
            );
        } else {
            return null;
        }
    }

    render() {
        const { handleSubmit, back, submitting, contractType, admin } = this.props;
        if (!admin) {
            return null;
        }

        const options = this.getOptions();

        return (
            <div className="contract-type">
                <div className="step-description">{this.getTypeStepDescription()}</div>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-sm-5">
                            <div className="contract-type-choice row">
                                <Field name="contractType" component={RadioField} options={options} selectedValue={contractType} />
                            </div>
                        </div>
                        <div className="col-sm-7 type-description-wrapper">
                            {!!contractType && (
                                <div className="type-description">
                                    <div className="row">{this.getDescription()}</div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <WizardButtons
                                disabled={submitting || !contractType || !['w2', 'ic'].includes(contractType)}
                                back={{ action: back }}
                                submit={{
                                    message: (
                                        <FormattedMessage
                                            id={'job.ProceedAs'}
                                            defaultMessage={'Proceed as {type}'}
                                            values={{ type: contractType.toLowerCase() === 'w2' ? 'individual' : 'business' }}
                                        />
                                    )
                                }}
                            />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

ChooseTypeStep = reduxForm(formSettings)(ChooseTypeStep);

const selector = formValueSelector('contractor-onboarding-wizard');
const mapStateToProps = (state, props) => {
    const { job, progress } = props;
    const iniContractType = job.classify_client_pref === 'ic-preferred' || job.classify_client_pref === 'ic-only' ? 'ic' : undefined;

    return {
        contractType: selector(state, 'contractType') ? selector(state, 'contractType') : '',
        icFailed: selector(state, 'icFailed') ? selector(state, 'icFailed') : false,
        reason: selector(state, 'reason') ? selector(state, 'reason') : '',
        comment: selector(state, 'comment') ? selector(state, 'comment') : '',
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        role: state.identity.role,
        job: state.jobs.list[0],
        initialValues: {
            contractType: progress && (progress.branch === 'w2' || progress.branch === 'ic') ? progress.branch : iniContractType
        }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin,
            setProgress,
            getJobs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ChooseTypeStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/intro/chooseType.jsx